<template>
  <div style="display:inline-block;">
    <a-input v-if="showInput" @click="openModal" placeholder="请点击选择题目" v-model="questionNames" readOnly :readOnly="disabled">
      <a-icon slot="prefix" type="bars" title="题目选择控件"/>
      <a-icon v-if="questionIds" slot="suffix" type="close-circle" @click="handleEmpty" title="清空"/>
    </a-input>
    <a-button class="select-btn" type="primary" v-else @click="openModal" icon="bars">{{buttonName}}</a-button>
    <TSelectQuestionModal
      ref="selectQuestionModal" 
      :modal-width="modalWidth"
      :question-id="questionIds"
      :multi="multi"
      @ok="handleOK"
      @initComp="initComp"
      />
  </div>
</template>

<script>
  import TSelectQuestionModal from './TSelectQuestionModal'
  export default {
    name: 'TSelectQuestion',
    components:{
      TSelectQuestionModal
    },
    props:{
      modalWidth:{
        type:Number,
        default:500,
        required:false
      },
      multi:{
        type:Boolean,
        default:false,
        required:false
      },
      //显示输入框
      showInput:{
        type:Boolean,
        default:true,
        required:false
      },
      buttonName: {
        type:String,
        required:false,
        default: '选择题目'
      },
      value:{
        type:String,
        required:false
      },
      disabled:{
        type: Boolean,
        required: false,
        default: false
      },
      // 自定义返回字段，默认返回 id
      customReturnField: {
        type: String,
        default: 'id'
      }
    },
    data(){
      return {
        visible:false,
        confirmLoading:false,
        questionNames:"",
        questionIds:''
      }
    },
    mounted(){
      this.questionIds = this.value
    },
    watch:{
      value(val){
        if (this.customReturnField === 'id') {
          this.questionIds = val
        }
      }
    },
    methods:{
      initComp(questionNames){
        this.questionNames = questionNames
      },
      openModal(){
        this.$refs.selectQuestionModal.open()
        console.log(this.questionNames);
      },
      handleOK(rows, idstr) {
        console.log(rows);
        console.log(idstr);
        let value = ''
        if (!rows && rows.length <= 0) {
          this.questionNames = ''
          this.questionIds = ''
        } else {
          value = rows.map(row => row[this.customReturnField]).join(',')
          this.questionNames = rows.map(row => row['questionName']).join(',')
          this.questionIds = idstr
        }
        this.$emit("change", value)
        this.$emit("ok", rows);
      },
      getQuestionNames(){
        return this.questionNames
      },
      handleEmpty(){
        this.handleOK('')
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style scoped>
</style>